// Copyright (c) StrangeBee 2023

import { CustomStatusController, CustomStatusInput, CustomStatusOutput } from 'thehive-sdk';

export interface CustomStatusEventList {
    case: {
        onCreate: (statusData: CustomStatusInput) => void;
        onEdit: (data: CustomStatusInput, statusId: string) => void;
        onDelete: (statusId: string) => void;
    };
    alert: {
        onCreate: (statusData: CustomStatusInput) => void;
        onEdit: (data: CustomStatusInput, statusId: string) => void;
        onDelete: (statusId: string) => void;
    };
}

interface CustomStatusEventListParams {
    locale: (label: string) => string;
    controller: CustomStatusController;
    onSuccess?: (count?: boolean, message?: string) => void;
    onError?: (label?: string) => void;
}

export const computeEventList = ({
    controller,
    locale,
    onError,
    onSuccess,
}: CustomStatusEventListParams): CustomStatusEventList => ({
    case: {
        onCreate: (statusData: CustomStatusInput) => {
            controller
                .createIn<CustomStatusInput, CustomStatusOutput>('case', statusData)
                .then(() => onSuccess?.(true, locale('notification.custom-status.create')))
                .catch(onError);
        },
        onEdit: (data: CustomStatusInput, statusId: string): void => {
            controller
                .editIn<Partial<CustomStatusInput>, void>('case', data, statusId)
                .then(() => onSuccess?.(false, locale('notification.custom-status.edit')))
                .catch(onError);
        },
        onDelete: (statusId: string): void => {
            controller
                .deleteIn('case', statusId)
                .then(() => onSuccess?.(false, locale('notification.custom-status.delete')))
                .catch(onError);
        },
    },
    alert: {
        onCreate: (statusData: CustomStatusInput) => {
            controller
                .createIn<CustomStatusInput, CustomStatusOutput>('alert', statusData)
                .then(() => onSuccess?.(true, locale('notification.custom-status.create')))
                .catch(onError);
        },
        onEdit: (data: CustomStatusInput, statusId: string): void => {
            controller
                .editIn<Partial<CustomStatusInput>, void>('alert', data, statusId)
                .then(() => onSuccess?.(false, locale('notification.custom-status.edit')))
                .catch(onError);
        },
        onDelete: (statusId: string): void => {
            controller
                .deleteIn('alert', statusId)
                .then(() => onSuccess?.(false, locale('notification.custom-status.delete')))
                .catch(onError);
        },
    },
});
